import React, { Fragment } from "react";
import { Cascader } from 'antd';

const defaultStyles = {
  color: '#1890FF',
  cursor: 'pointer',
}

export default class ResponseSwitcher extends React.Component {
  render() {
    return (
      <Fragment>
        <Cascader value={[this.props.value]}
                  options={this.props.options}
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
        >
          <span style={{ ...defaultStyles, ...this.props.styles, fontSize: "2em" }}>{this.props.label}</span>
        </Cascader>
      </Fragment>
    );
  }
}
